import { styled } from '@volkswagen-onehub/components-core';

export const WhiteLinkWrapper = styled.span`
  a {
    color: #ffffff;
    font-weight: bold;
  }
`;
